export function criarUsuarioDraft(pessoaId = null, origem = {}, usuario = false) {
    const dados = origem || {};
    return {
        ...dados,
        pessoaId: pessoaId ?? dados.pessoaId ?? null,
        usuario: dados.usuario ?? '',
        perfil: dados.perfil ?? '',
        ativo: dados.ativo ?? usuario ?? false,
        senha: '',
        confirmeSenha: '',
    };
}
